import { TherapeuticGroupOccupancy } from '@dreryk/egabinet-group-session-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigSingleSelection,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { GroupSessionsFilterPanelSearchParam } from '../../GroupSessionsFilterPanel.types';
import { OCCUPANCIES } from '../../GroupSessionsFilterPanel.constants';

const OCCUPANCY_TO_SEARCH_PARAM: Record<TherapeuticGroupOccupancy, number> = {
   FULL: 0,
   HAS_VACANCIES: 1,
};

export const createOccupancyTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenOccupancy: TherapeuticGroupOccupancy) => string) => {
   return (chosenOccupancy) => {
      return translate(translationKeys.occupancyMap[chosenOccupancy]);
   };
};

export const occupancyCodec: FilterPanelControllerCodecConfigSingleSelection<TherapeuticGroupOccupancy> = {
   type: 'single-selection',
   keyGenerator: (occupancy) => (occupancy ? OCCUPANCY_TO_SEARCH_PARAM[occupancy] : undefined),
   items: OCCUPANCIES,
};

export const occupancyDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   TherapeuticGroupOccupancy,
   GroupSessionsFilterPanelSearchParam.OCCUPANCY
> = (currentOccupancy) => {
   return [
      {
         targetValue: null,
         label: translationKeys.occupancyMap[currentOccupancy],
         testId: `occupancy-${currentOccupancy}`,
      },
   ];
};

export const occupancyDeserializer = (currentParamValue: string | null): TherapeuticGroupOccupancy | null => {
   return FilterPanel.paramToSingleValue(
      currentParamValue,
      'number',
      (item) => OCCUPANCIES.find((occupancy) => OCCUPANCY_TO_SEARCH_PARAM[occupancy] === item)!
   );
};
